import { render, staticRenderFns } from "./BsApply.vue?vue&type=template&id=2596cfca&scoped=true&"
import script from "./BsApply.vue?vue&type=script&lang=js&"
export * from "./BsApply.vue?vue&type=script&lang=js&"
import style0 from "./BsApply.vue?vue&type=style&index=0&id=2596cfca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596cfca",
  null
  
)

export default component.exports